import { FlexRow } from '@editor/components/utilities/layouts';
import { H4, H6 } from '@repo/ui/components/Typography';
import { handleTextOverflow } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const InnerWrapper = styled.div<{
  hasLabelPrefix?: boolean;
}>`
  flex: 1;
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;

  margin-left: ${({ hasLabelPrefix }) =>
    hasLabelPrefix
      ? '8'
      : '0'}px; /* 8px = 5 (padding of select) + 3 (offset) */
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight};
  font-size: ${({ theme }) => theme.fontSize};
  line-height: ${({ theme }) => theme.lineHeight};
  color: ${({ theme }) => theme.colorLabel};
  letter-spacing: ${({ theme }) => theme.letterSpacing};
  text-transform: ${({ theme }) => theme.textTransform};
  user-select: none;
  padding: ${({ theme }) => theme.padding};
  line-height: ${({ theme }) => theme.lineHeight};

  ${handleTextOverflow}
`;

export const NewThemeLabel = styled(H4)`
  color: ${({ theme }) => theme.colorLabel};
  user-select: none;
  padding: ${({ theme }) => theme.padding};

  ${handleTextOverflow};
`;

export const IconWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  right: 0px;
`;

export const ClickableArea = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
`;

export const BackButtonWrapper = styled(FlexRow)`
  width: fit-content;
  cursor: pointer;
  align-items: center;
  gap: 6px;
`;

export const CloseIconWrapper = styled.div`
  cursor: pointer;
`;

export const BackButtonLabel = styled(H6)`
  color: ${themeStyle.varInkMedium};

  &:hover {
    color: ${themeStyle.varInkMain};
  }
`;

export const TagWrapper = styled.div`
  margin-left: 6px;
`;
